import {
  GET_WHITELABELS,
  GET_WHITELABELS_SUCCESS,
  GET_WHITELABELS_FAILURE,
} from "../actionTypes";

export const getWhitelabels = (payload) => ({
  type: GET_WHITELABELS,
  payload,
});

export const getWhitelabelsSuccess = (payload) => ({
  type: GET_WHITELABELS_SUCCESS,
  payload,
}

);

export const getWhitelabelsFailure = () => ({
  type: GET_WHITELABELS_FAILURE,
});
